import styled, { css } from 'styled-components'

type CollapseProps = {
  isCollpased?: boolean
}

export const Wrapper = styled.div<CollapseProps>`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 10px;
  padding: 24px;
  max-width: 400px;
  transition: all 0.5s ease;

  ${(props) =>
    props.isCollpased &&
    css`
      max-width: 125px;

      h1 {
        font-size: ${({ theme }) => theme.font.sizes.small};
        inline-size: 100px;
      }

      div,
      section {
        display: none;
      }
    `}
`

export const Header = styled.header<CollapseProps>`
  section {
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      cursor: pointer;
      transform: rotate(180deg);
    }

    ${(props) =>
      props.isCollpased &&
      css`
        img {
          transform: rotate(0);
        }
      `}
  }
`

export const Name = styled.h1`
  font-size: ${({ theme }) => theme.font.sizes.xlarge};
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 700;
  margin-bottom: 8px;
  margin-right: 4px;
  inline-size: 350px;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Contact = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: center;

  img {
    margin-right: 8px;
    height: 18px;
  }

  label {
    font-size: ${({ theme }) => theme.font.sizes.small};
    color: ${({ theme }) => theme.colors.lightGray};
    line-break: anywhere;
  }
`

export const Pendencies = styled.section`
  margin-top: 32px;
  padding-bottom: 24px;
  border-bottom: 0.7px solid rgba(69, 90, 100, 0.2);
`

export const PendenciesTitle = styled.h2`
  font-size: ${({ theme }) => theme.font.sizes.medium};
  color: ${({ theme }) => theme.colors.gray};
  text-transform: uppercase;
`

export const PendenciesContent = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

export const Pendency = styled.span`
  font-size: ${({ theme }) => theme.font.sizes.small};
  color: #b95000;
  font-weight: 500;
  text-transform: capitalize;
  padding: 5px 16px;
  background-color: #fff4ec;
  border: 1px solid #b95000;
  border-radius: 100px;
  margin-right: 16px;
  margin-top: 16px;
`

export const Complement = styled.section`
  padding: 24px 0;
  border-bottom: 0.7px solid rgba(69, 90, 100, 0.2);
  display: flex;
  flex-direction: column;

  > *:last-child {
    margin-bottom: 0;
  }
`

export const ComplementItem = styled.span`
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.gray};
  text-transform: uppercase;
  margin-bottom: 8px;
`

export const Units = styled.section`
  padding: 24px 0;
  border-bottom: 0.7px solid rgba(69, 90, 100, 0.2);

  ul {
    margin-top: 12px;
    padding-left: 24px;

    > li:last-child {
      margin-bottom: 0;
    }
  }
`

export const UnitsTitle = styled.h2`
  font-size: ${({ theme }) => theme.font.sizes.medium};
  color: ${({ theme }) => theme.colors.gray};
  text-transform: uppercase;
  font-weight: 500;
`

export const Unit = styled.li`
  font-size: ${({ theme }) => theme.font.sizes.small};
  color: ${({ theme }) => theme.colors.lightGray};
  margin-bottom: 8px;
`

export const ActingSectors = styled.section`
  margin-top: 16px;

  ul {
    margin-top: 12px;
    padding-left: 24px;

    > li:last-child {
      margin-bottom: 0;
    }
  }
`

export const ActingSectorsTitle = styled.h2`
  font-size: ${({ theme }) => theme.font.sizes.medium};
  color: ${({ theme }) => theme.colors.gray};
  text-transform: uppercase;
  font-weight: 500;
`

export const ActingSector = styled.li`
  font-size: ${({ theme }) => theme.font.sizes.small};
  color: ${({ theme }) => theme.colors.lightGray};
  margin-bottom: 8px;
`
